import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { capitalCase } from 'change-case';
import { Tooltip, Badge, IconButton, SvgIcon, Popover, Typography, Box, FormControlLabel, Switch, TextField, Button } from '@mui/material';
import { Settings as Settings$1 } from 'react-feather';
import { useSettings } from '../../../hooks/useSettings.js';
import '../../../contexts/SettingsContext.js';
import '../../../global/constants/index.js';

const PREFIX = 'Settings';
const classes = {
    badge: `${PREFIX}-badge`,
};
const Root = styled('div')(() => ({
    [`& .${classes.badge}`]: {
        height: 10,
        width: 10,
        borderRadius: 5,
        marginTop: 10,
        marginRight: 5,
    },
}));
const Settings = ({ themes }) => {
    const ref = useRef(null);
    const { settings, saveSettings } = useSettings();
    const [isOpen, setOpen] = useState(false);
    const [values, setValues] = useState(Object.assign({}, settings));
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (field, value) => {
        setValues(Object.assign(Object.assign({}, values), { [field]: value }));
    };
    const handleSave = () => {
        saveSettings(values);
        setOpen(false);
    };
    const themeOptions = () => {
        if (values.themes) {
            return values.themes.map((theme) => {
                return (jsx("option", Object.assign({ value: theme.name }, { children: capitalCase(theme.name) }), theme.name));
            });
        }
        return Object.keys(themes).map(theme => (jsx("option", Object.assign({ value: theme }, { children: capitalCase(theme) }), theme)));
    };
    return (jsxs(Root, { children: [jsx(Tooltip, Object.assign({ title: "Configura\u00E7\u00F5es" }, { children: jsx(Badge, Object.assign({ color: "secondary", classes: { badge: classes.badge } }, { children: jsx(IconButton, Object.assign({ color: "inherit", onClick: handleOpen, ref: ref }, { children: jsx(SvgIcon, Object.assign({ fontSize: "small" }, { children: jsx(Settings$1, {}) })) })) })) })), jsxs(Popover, Object.assign({ anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, anchorEl: ref.current, onClose: handleClose, open: isOpen, sx: {
                    '& .MuiPopover-paper': {
                        width: 320,
                        padding: 2,
                    },
                } }, { children: [jsx(Typography, Object.assign({ variant: "h4", color: "textPrimary" }, { children: "Configura\u00E7\u00F5es" })), jsx(Box, Object.assign({ mt: 2, px: 1 }, { children: jsx(FormControlLabel, { control: jsx(Switch, { checked: values.responsiveFontSizes, edge: "start", name: "direction", onChange: event => handleChange('responsiveFontSizes', event.target.checked), color: "secondary" }), label: "Fontes responsivas" }) })), jsx(Box, Object.assign({ mt: 2 }, { children: jsx(TextField, Object.assign({ fullWidth: true, label: "Temas", name: "theme", onChange: event => handleChange('theme', event.target.value), select: true, SelectProps: { native: true }, value: values.theme }, { children: themeOptions() })) })), jsx(Box, Object.assign({ mt: 2 }, { children: jsx(Button, Object.assign({ variant: "contained", color: "secondary", fullWidth: true, onClick: handleSave }, { children: "Salvar configura\u00E7\u00F5es" })) }))] }))] }));
};

export { Settings };
